import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import classes from '../PatternRegistryForm.module.scss';

const FieldDefinitionHeader = () => {
  const { t: translate } = useTranslation();
  return (
    <div data-testid="pr-fd-list-header">
      <div className={classes['pr-list-header']}>
        <Row>
          <Col sm={10}>
            <Row className="row no-gutters">
              <Col sm={1} className={classes['fd-name-header']}>
                {translate('pattern_registry_form.required')}
              </Col>
              <Col sm={2} className={classes['fd-name-header']}>
                {translate('pattern_registry_form.fd_list_name')}
              </Col>
              <Col sm={3} className={classes['fd-operator-header']}>
                {translate('pattern_registry_form.fd_list_operator')}
              </Col>
              <Col sm={2} className={classes['fd-value-header']}>
                {translate('pattern_registry_form.fd_list_value')}
              </Col>
              <Col sm={2} className={classes['fd-content-type-header']}>
                {translate('pattern_registry_form.fd_list_content_type')}
              </Col>
              <Col sm={2} className={classes['fd-content-type-header']}>
                {translate('pattern_registry_form.conversion_pattern')}
              </Col>
            </Row>
          </Col>
          <Col sm={2} />
        </Row>
      </div>
    </div>
  );
};

export default FieldDefinitionHeader;
